module.exports = __webpack_public_path__ + "4f5393907f05f77f47e6175cf4a2d37c.svg";